export default __webpack_public_path__ + "static/plasmafinance-c3ce376b6c2d0a42302ac23feb6018fe.jpg";